/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// Help, Define a custom non-enumerable sortBy function using a Schwartzian transform on all arrays : ,  https://stackoverflow.com/questions/10123953/sort-javascript-object-array-by-date
(function () {
  function sb(f) {
    for (var i = this.length; i; ) {
      var o = this[--i];
      this[i] = [].concat(f.call(o, o, i), o);
    }
    this.sort(function (a, b) {
      for (var i = 0, len = a.length; i < len; ++i) {
        if (a[i] !== b[i]) {
          return a[i] < b[i] ? -1 : 1;
        }
      }
      return 0;
    });
    for (var z = this.length; z; ) {
      this[--z] = this[z][this[z].length - 1];
    }
    return this;
  }

  if (typeof Object.defineProperty === "function") {
    try {
      Object.defineProperty(Array.prototype, "sortBy", { value: sb });
    } catch (e) {}
  }

  if (!Array.prototype.sortBy) {
    Array.prototype.sortBy = sb;
  }
})();

function getUrlParams(url) {
  // http://stackoverflow.com/a/23946023/2407309
  if (typeof url === "undefined") {
    url = window.location.search;
  }
  url = url.split("#")[0]; // Discard fragment identifier.
  var urlParams = {};
  var queryString = url.split("?")[1];
  if (!queryString) {
    if (url.search("=") !== false) {
      queryString = url;
    }
  }
  if (queryString) {
    var keyValuePairs = queryString.split("&");
    for (var i = 0; i < keyValuePairs.length; i++) {
      var keyValuePair = keyValuePairs[i].split("=");
      var paramName = keyValuePair[0];
      var paramValue = keyValuePair[1] || "";
      urlParams[paramName] = decodeURIComponent(paramValue.replace(/\+/g, " "));
    }
  }
  return urlParams;
} // getUrlParams

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        jQuery(function () {
          var logoSrc = jQuery("header img.logo ").attr("src");
          var siteUrl = jQuery("header .logo-link").attr("href");

          jQuery(".primary-nav").slicknav({
            label: "",
            brand: '<a href="' + siteUrl + '" class="logo-img-wrapper"></a>',
            allowParentLinks: true,
          });

          jQuery(".slicknav_menu .logo-img-wrapper").append(
            '<img class="sm-logo" src="' + logoSrc + '" alt="brand logo" />'
          );
        });

        /*
         *
         * Event type select
         */
        $(document).on("change", "#event-type-select, #event-topic-select", function (e) {
          var selected_type_id = $("#event-type-select").val();
          var selected_topic_id = $("#event-topic-select").val();
          console.log("Type ID: " + selected_type_id);
          console.log("Topic ID: " + selected_topic_id);

          jQuery(".event-list__item").each(function () {
            jQuery(this).removeClass("event-list__item--hide");
            var event_ids = jQuery(this).data("terms");

            if ((selected_type_id && !event_ids.includes(selected_type_id)) || 
                (selected_topic_id && !event_ids.includes(selected_topic_id))) {
              jQuery(this).addClass("event-list__item--hide");
            }
          });
        });

        /*
         *
         * Event organization select
         */
        $(document).on("change", "#event-organization-select", function (e) {
          jQuery("#event-type-select, #event-topic-select").prop("selectedIndex", 0);
          var selected_id = this.options[e.target.selectedIndex].value;
          console.log(selected_id);
          jQuery(".event-list__item").each(function () {
            jQuery(this).removeClass("event-list__item--hide");
            var event_ids = jQuery(this).data("organization");
            if (event_ids !== selected_id && selected_id !== "all") {
              jQuery(this).addClass("event-list__item--hide");
            }
          });
        });
      },
      
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        var url = window.location.href;
        var params = getUrlParams(url);
        if (params.s && params.s !== "") {
          jQuery("input#search_text").val(params.s);
        }

        // jQuery('.search-select-cat')
        //   .select2({
        //     placeholder: 'Kategoria',
        //     allowClear: true,
        //     tags: true,
        //   })
        //   .on('select2:select', function (e) {
        //     var selected_element = $(e.currentTarget);
        //     window.location.href = selected_element.val();
        //   });

        function startSearch() {
          var text = jQuery("input#search_text").val();
          console.log(text);
          if (params.s) {
            window.location.href =
              window.location.origin + window.location.pathname + "?s=" + text;
          } else {
            window.location.href = url + "?s=" + text;
          }
        }

        $("input#search_text").on("keyup", function (e) {
          if (e.key === "Enter" || e.keyCode === 13) {
            startSearch();
          }
        });

        jQuery(".search-btn").on("click", function () {
          startSearch();
        });

        // eTaika
        // if( jQuery('#eTaikaEvents').length ) {
        //   var url = jQuery('#eTaikaEvents').attr('data-url');

        //   fetch(url)
        //   .then( response => response.json() )
        //     .then(function(data) {
        //       console.log(data)

        //       if(!data || data.length <= 0) return

        //       // Sort
        //       data.sortBy(function(o){ return new Date(o.Alkuaika) });

        //       let container = jQuery('#eTaikaEvents');
        //       let calc = 0;
        //       for (let i of data) {
        //         if(calc >= 6) {break;}
        //         calc++;
        //         let desc = '';
        //         i.Sisalto ? desc = i.Sisalto : desc = i.Paikka;
        //         container.append('<div class="col-12 col-md-6 col-lg-4 single-event" id="'+i.TapahtumaID+'"><p class="date">'+i.Ajankohta+'</p><p class="name">'+i.Nimi+'</p><p class="description">'+desc+'</p><a class="link" href="'+i.TutustuTarkemminUrl+'">Katso lisää &gt;</a></div>');
        //       }
        //       let len = data.length;
        //       jQuery('.show-newest-events .events-quantity').html(len.toString());

        //     }).catch(function(r) {
        //       console.log('Could not fetch eTaika events. The .show-newest-events block will now be hidden.');
        //       console.error(r);
        //       jQuery('section.show-newest-events').hide();
        //     });

        // }

        // Hover efect to submenus
        jQuery("#menu-primary-menu .menu-item-has-children").on(
          "hover",
          function () {
            jQuery(this).find(".sub-menu").toggleClass("show");
          }
        );

        function setSingleBoxHeights() {
          jQuery(".single-box").each(function (index) {
            var width = jQuery(this).width();
            var height = jQuery(this).height();
            if (width !== height) {
              jQuery(this).height(width);
            }
          });
        }
        setSingleBoxHeights();
        // Set single-box height same as width
        jQuery(window).resize(function () {
          setSingleBoxHeights();
        });

        // HEader swiper
        if (jQuery("#headerWideSwiper").length) {
          new Swiper("#headerWideSwiper", {
            speed: 1600,
            spaceBetween: 0,
            loop: true,
            effect: "fade",
            autoplay: true,
            // pagination: {
            //    el: '.swiper-pagination',
            //    type: 'progressbar',
            //  },
            //  renderProgressbar: function (progressbarFillClass) {
            //        return '<span class="' + progressbarFillClass + '"></span>';
            //    },
            //    fadeEffect: {
            //       crossFade: true
            //     },
          });
        }
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
